import { Button } from '@mui/material';
import { useIntl } from 'react-intl';

const OneTrustCookieSettings = () => {
  const { formatMessage } = useIntl();

  const handleClick = () => {
    if ((window as any).OneTrust) {
      (window as any).OneTrust.ToggleInfoDisplay();
    }
  };

  return (
    <Button
      id="ot-sdk-btn"
      className="ot-sdk-show-settings"
      onClick={handleClick}
      sx={{
        display: 'inline-block !important',
        color: 'white !important',
        backgroundColor: 'transparent !important',
        border: 'none !important',
        textTransform: 'uppercase !important',
        fontWeight: '500 !important',
        letterSpacing: '0.6px !important',
        fontSize: '14px !important',
        padding: '0 !important',
        marginBottom: '10px !important',
        lineHeight: '1.6 !important',
        '&:hover': {
          color: '#FABA45 !important',
        },
      }}
    >
      {formatMessage({ id: 'nav.cookies' })}
    </Button>
  );
};

export default OneTrustCookieSettings;
